// extracted by css-extract-rspack-plugin
export default {"svgIcon":"svgIcon-NMxzSO"};